import "./styles.scss";

import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";
import avatarImage from "assets/images/avatar-placeholder.png";

const mainClass = "settings-layout-user-mobile";

const UserMobile = ({ header, content }) => {
  return (
    <div className={mainClass}>
      {header?.title && (
        <div className={`${mainClass}__header`}>
          <p>{header.title}</p>
          {header?.action?.label && (
            <button type="button" onClick={header.action?.onClick}>
              {header.action.label}
              <i>
                <ArrowIcon />
              </i>
            </button>
          )}
        </div>
      )}
      <div className={`${mainClass}__content`}>
        <div className={`${mainClass}__content-avatar`}>
          <div>
            <img src={content?.avatar || avatarImage} alt="" />
          </div>
        </div>
        <div className={`${mainClass}__content-data`}>
          {content?.name && <h6>{content.name}</h6>}
          {content?.email && <p>{content.email}</p>}
          {content?.phone && <p>{content.phone}</p>}
        </div>
      </div>
    </div>
  );
};

export default UserMobile;
